export function getValueId(entryId: string, fieldId: string): string {
  return `${entryId}_${fieldId}`;
}

export enum MultiValueChangeType {
  SET_TO,
  EDIT,
  APPEND,
  REMOVE,
  REORDER,
}

// Loose types for handler compatibility — to be refined later
export type ValueChange = any;
export type DatabaseChange = any;

export const getHiddenFieldsCountBeforeIndex = (
  hiddenFields: string[],
  allFields: readonly string[],
  idx: number
) =>
  hiddenFields.filter((hiddenField) => {
    const hiddenFieldIndex = allFields?.indexOf(hiddenField);
    return hiddenFieldIndex >= 0 && hiddenFieldIndex <= idx;
  }).length;

export const getNewIndexWithHiddenFields = (
  idx: number,
  allFields: readonly string[],
  hiddenFields: string[] | undefined
) => {
  if (hiddenFields?.length) {
    const hiddenFieldsCountBeforeIndex = getHiddenFieldsCountBeforeIndex(
      hiddenFields,
      allFields,
      idx
    );
    return hiddenFieldsCountBeforeIndex > 0 ? idx + hiddenFieldsCountBeforeIndex : idx;
  } else {
    return idx;
  }
};

function isUniqueFieldName(fieldName: string, existingFieldNames: string[]): boolean {
  return !existingFieldNames.some(
    (name) => name.toLowerCase() === fieldName.toLowerCase()
  );
}

export function getUniqueFieldName(
  fieldName: string,
  existingFieldNames: string[]
): string {
  if (isUniqueFieldName(fieldName, existingFieldNames)) {
    return fieldName;
  } else {
    for (let fieldSuffixId = 1; true; fieldSuffixId++) {
      const name = `${fieldName} ${fieldSuffixId}`;
      if (isUniqueFieldName(name, existingFieldNames)) {
        return name;
      }
    }
  }
}
